import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ContactModal } from './ContactModal';
// Extra vertical offset per section so the nav buttons land in the exact
// same spot as the side-nav buttons in pages/Home.tsx.
const SECTION_EXTRA_OFFSET: Record<string, number> = {
  colecciones: 0,
  'mas-alla': 120,
  nosotros: 184
};
export function Nav() {
  const [solid, setSolid] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const contactTriggerRef = useRef<HTMLButtonElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const target = document.getElementById(id);
    if (!target) return;
    const nav = document.getElementById('nav');
    const offset = (nav?.offsetHeight ?? 0) + 24;
    const extra = SECTION_EXTRA_OFFSET[id] ?? 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset + extra;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };
  const handleSectionClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // Navigate home first, then scroll once the section is mounted.
      navigate('/');
      window.setTimeout(() => scrollToSection(id), 80);
      return;
    }
    scrollToSection(id);
  };
  const closeContact = () => {
    setIsContactOpen(false);
    window.setTimeout(() => contactTriggerRef.current?.focus(), 0);
  };
  return <>
      <nav className={`nav ${solid ? 'nav--solid' : ''}`} id="nav" data-id="element-154">
        <Link to="/#inicio" className="nav__logo" onClick={e => {
        e.preventDefault();
        if (location.pathname !== '/') {
          navigate('/');
          window.setTimeout(() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          }), 80);
          return;
        }
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} data-id="element-155">
          SAVIA
        </Link>
        <ul className="nav__links" data-id="element-156">
          <li data-id="element-157">
            <Link to="/#colecciones" onClick={e => handleSectionClick(e, 'colecciones')} data-id="element-158">
              Colecciones
            </Link>
          </li>
          <li data-id="element-159">
            <Link to="/#mas-alla" onClick={e => handleSectionClick(e, 'mas-alla')} data-id="element-160">
              Kits & Objetos
            </Link>
          </li>
          <li data-id="element-161">
            <Link to="/#nosotros" onClick={e => handleSectionClick(e, 'nosotros')} data-id="element-162">
              Nosotros
            </Link>
          </li>
          <li data-id="element-163">
            <button ref={contactTriggerRef} type="button" className="nav__contact" onClick={() => setIsContactOpen(true)} aria-haspopup="dialog" aria-expanded={isContactOpen} data-id="element-164">
              Contacto
            </button>
          </li>
        </ul>
        <button className="nav__hamburger" aria-label="Menú" data-id="element-165">
          <span data-id="element-166"></span>
          <span data-id="element-167"></span>
          <span data-id="element-168"></span>
        </button>
      </nav>
      <ContactModal isOpen={isContactOpen} onClose={closeContact} data-id="element-169" />
    </>;
}